module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cKIQm"))).then(() => parcelRequire('d0iPb'));